import { NgModule } from '@angular/core';
import { FormFieldComponent } from './form-field.component';
import { FeedbackMessageComponent } from './feedback-message.component';
import { InputFieldDirective } from './input-field.directive';

const COMPONENTS = [FeedbackMessageComponent];
const MODULES = [FormFieldComponent, InputFieldDirective];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...MODULES, ...COMPONENTS]
})
export class FormFieldModule {}
